import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=1275f484&scoped=true"
import script from "./checkbox.vue?vue&type=script&lang=ts"
export * from "./checkbox.vue?vue&type=script&lang=ts"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=1275f484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275f484",
  null
  
)

export default component.exports